<template>
  <div id="events">
    <SearchFilter @openFilter="filter" />
    <div class="events-list">
      <ul v-if="events.length">
        <li v-for="event in events" :key="event.id" class="list-box">
          <div
            @click="openPopup(event.name)"
            class="img-title"
            :style="{
              backgroundImage: event.thumbnailUrl
                ? 'url(' + event.thumbnailUrl + ')'
                : null,
            }"
          >
            <div class="text-center">
              <span class="month">{{
                getMonthEvent(
                  event.eventTime.startDate,
                  event.eventTime.endDate
                )
              }}</span>
              <br />
              <span class="days">{{
                getDayEvent(event.eventTime.startDate, event.eventTime.endDate)
              }}</span>
            </div>
          </div>
          <div class="detail" @click="openPopup(event.name)">
            <div class="title">
              <span>{{ event.title }}</span>
            </div>
            <div class="description">
              {{ event.description | truncate(110) }}
              <span class="more">More</span>
            </div>
          </div>
        </li>
      </ul>
      <ul v-else>
        <li class="event-null">
          There are no events that match your criteria.
        </li>
      </ul>
    </div>
    <div class="filter" :class="{ activeFilter: activeFilter }">
      <div class="year">
        <p>Year</p>
        <div class="chose-year">
          <label class="filter-checkbox">
            <input type="checkbox" checked="checked" />
            <span class="checkmark">2019</span>
          </label>
          <label class="filter-checkbox">
            <input type="checkbox" />
            <span class="checkmark">2020</span>
          </label>
          <label class="filter-checkbox">
            <input type="checkbox" />
            <span class="checkmark">2021</span>
          </label>
        </div>
        <p>Month</p>
        <div class="chose-month">
          <label class="filter-checkbox">
            <input type="checkbox" />
            <span class="checkmark">Jan</span>
          </label>
          <label class="filter-checkbox">
            <input type="checkbox" />
            <span class="checkmark">Feb</span>
          </label>
          <label class="filter-checkbox">
            <input type="checkbox" />
            <span class="checkmark">Mar</span>
          </label>
          <label class="filter-checkbox">
            <input type="checkbox" />
            <span class="checkmark">Apr</span>
          </label>
          <label class="filter-checkbox">
            <input type="checkbox" />
            <span class="checkmark">May</span>
          </label>
          <label class="filter-checkbox">
            <input type="checkbox" />
            <span class="checkmark">Jun</span>
          </label>
          <label class="filter-checkbox">
            <input type="checkbox" />
            <span class="checkmark">Jul</span>
          </label>
          <label class="filter-checkbox">
            <input type="checkbox" />
            <span class="checkmark">Aug</span>
          </label>
          <label class="filter-checkbox">
            <input type="checkbox" />
            <span class="checkmark">Sep</span>
          </label>
          <label class="filter-checkbox">
            <input type="checkbox" />
            <span class="checkmark">Oct</span>
          </label>
          <label class="filter-checkbox">
            <input type="checkbox" />
            <span class="checkmark">Nov</span>
          </label>
          <label class="filter-checkbox">
            <input type="checkbox" />
            <span class="checkmark">Dec</span>
          </label>
        </div>
        <p>Regions</p>
        <div class="chose-regions">
          <label
            class="filter-checkbox"
            v-for="(region, index) in regions"
            :key="index"
          >
            <input
              type="checkbox"
              v-model="regionCheckbox"
              :value="region.id"
              @change="resetPage"
            />
            <span class="checkmark">{{ region.title }}</span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import SearchFilter from "@/components/SearchFilter";
import bgEventTitle from "@/assets/img/bg-events.jpg";
import EventService from "@/services/event";
import * as moment from "moment";

export default {
  name: "events",
  components: {
    SearchFilter,
  },
  props: {
    perPage: {
      type: Number,
      default: 30,
    },
  },
  data() {
    return {
      activeFilter: false,
      bgEventTitle: bgEventTitle,
      regions: [],
      events: [],
      final: true,
      page: 1,
      regionCheckbox: [],
    };
  },
  methods: {
    filter(value) {
      this.activeFilter = value;
    },
    reset() {
      this.final = true;
      this.events = [];
      this.page = 1;
    },
    resetPage() {
      this.page = 1;
      this.load();
    },
    load() {
      const url = process.env.VUE_APP_API_URI;
      const postData = {
        query: `query events($page: Int, $limit: Int, $locations: [ID]) { events(page: $page, limit: $limit, locations: $locations) { final data { id title name thumbnailUrl description eventTime{ startDate endDate } } } }`,
        variables: {
          page: this.page,
          limit: this.perPage,
          locations: this.regionCheckbox,
        },
      };
      axios
        .post(url, postData, {
          headers: {
            "X-API-Key": process.env.VUE_APP_API_KEY,
          },
        })
        .then((res) => {
          this.events = res.data.data.events.data;
          this.final = res.data.data.events.final;
          console.log(this.events);
        })
        .catch(console.error);
    },
    loadNext() {
      this.page++;
      this.load();
    },

    openPopup(name) {
      console.log(name);
      EventService.openPopup(name);
    },
    getMonthEvent(startDate, endDate) {
      return moment.utc(startDate).format("MMM");
    },
    getDayEvent(startDate, endDate) {
      const monthStart = moment.utc(startDate).format("MMM");
      const monthEnd = moment.utc(endDate).format("MMM");
      if (!moment.utc(startDate).isSame(endDate, "month")) {
        return moment.utc(startDate).format("D");
      } else {
        if (moment.utc(startDate).isSame(endDate, "day")) {
          return moment.utc(startDate).format("D");
        } else {
          return (
            moment.utc(startDate).format("D") +
            " - " +
            moment.utc(endDate).format("D")
          );
        }
      }
    },
  },
  mounted() {
    this.regions = this.$store.state.ref.locations;
    this.load();
  },
};
</script>

<style lang="scss" scoped>
#events {
  padding-top: 52px;

  .events-list {
    padding-top: 44px;
    ul {
      list-style: none;
      padding: 0;

      .list-box {
        display: flex;
        border-bottom: 1px #cccccc solid;
        .img-title {
          width: 33.33%;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: center;
          background-size: cover;
          color: #fff;
          .month {
            font-size: 12px;
            font-weight: bold;
            line-height: 12px;
          }

          .days {
            font-size: 32px;
            font-weight: bold;
            line-height: 25px;
          }
        }

        .detail {
          width: 67%;
          padding: 20px;
          flex: 1 1 auto;

          .title {
            font-size: 13px;
            font-weight: bold;
          }

          .description {
            font-size: 10px;
          }
        }
      }

      .event-null {
        padding: 80px 20px;
        text-align: center;
        font-size: 20px;
      }
    }
  }

  .filter {
    padding: 54px 10px 0;
    position: fixed;
    transition: 0.2s ease;
    height: calc(100vh - 52px);
    width: 80%;
    top: 52px;
    right: -80%;
    background-color: #fff;

    &.activeFilter {
      right: 0;
    }

    .year {
      p {
        padding-left: 5px;
        font-size: 13px;
        font-weight: bold;
      }

      .chose-year {
        display: flex;
        margin-bottom: 10px;
      }
      .chose-month {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 10px;
        .filter-checkbox {
          width: 16.66%;
        }
      }
      .chose-regions {
        margin-bottom: 10px;
      }

      .filter-checkbox {
        display: block;
        position: relative;
        padding-left: 5px;
        margin-bottom: 12px;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;

        .checkmark {
          font-size: 13px;
          font-weight: bold;
          color: #aaaaaa;
          border-radius: 12px;
          padding: 4px 5px;
        }

        input {
          position: absolute;
          opacity: 0;
          cursor: pointer;
          height: 0;
          width: 0;

          &:checked ~ .checkmark {
            color: #fff;
            background-color: #e13036;
          }
        }
      }
    }
  }
}
</style>
